import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'HintText',
  props: {
    hintText: {},
    disabled: { type: Boolean },
    noIndent: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pt-1 text-xs", [_ctx.disabled ? 'text-gray-50' : 'text-gray-80', { 'pl-4': !_ctx.noIndent }]])
  }, _toDisplayString(_ctx.hintText), 3))
}
}

})